
export enum OperatorTypeEnum {
    Equals = "Equals",
    NotEquals = "Not Equals",
    GreaterThan = "Greater Than",
    LessThan = "Less Than",
    GreaterThanOrEqual = "Greater Than Or Equal",
    LessThanOrEqual = "Less Than Or Equal"
}

export const OperatorTypeEnumList: {
    key: string;
    value: string;
}[] = Object.entries(OperatorTypeEnum)
    .map(([key, value]) => ({ key, value }));


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/rules/directives/rulesDialog/models/operatorTypeEnum.ts
 **/